import React, {ReactNode} from 'react';

interface ButtonProps {
    onClick: (any?) => any,
    children: ReactNode,
    additionalClasses?: string,
    style?: object,
    disabled?: boolean,
    className:
        'green' |
        'green-outline' |
        'blue' |
        'orange' |
        'red' |
        'border' |
        'inline' |
        'inactive' |
        'inactive-green' |
        'compact' |
        'disabled' |
        'mobile' |
        'dismiss' |
        'primary' |
        'secondary' |
        'primary-outline' |
        'secondary-outline' |
        'primary-transparent' |
        'secondary-transparent',
}

const Button = ({children, className, onClick, disabled, additionalClasses = "", style}: ButtonProps) => (
    <button
        disabled={disabled}
        type="button"
        onClick={onClick}
        style={style}
        className={`btn btn--${className} ${additionalClasses}`}
    >
        {children}
    </button>
)

export default Button;